import { Routes } from '@angular/router';
import { MsalGuard, MsalRedirectComponent } from '@azure/msal-angular';

import { notImpersonatingGuard } from './core/guards/not-impersonating-guard';
import { powerUserGroupGuard } from './core/guards/power-user-group-guard';
import { Unauthorized } from './status-pages/unauthorized/unauthorized';
import { timeSheetUnsavedChangesGuard } from './time-sheet/guards/time-sheet-unsaved-changes-guard';
import { TimeSheet } from './time-sheet/time-sheet';
import { UploadTimeSheet } from './upload-time-sheet/upload-time-sheet';

export const ROUTES: Routes = [
  {
    path: 'auth',
    component: MsalRedirectComponent,
  },
  {
    title: 'TimeHub - Timesheet',
    path: '',
    component: TimeSheet,
    canActivate: [MsalGuard],
    canDeactivate: [timeSheetUnsavedChangesGuard],
  },
  {
    title: 'TimeHub - Upload',
    path: 'upload',
    canActivate: [MsalGuard],
    component: UploadTimeSheet,
  },
  {
    title: 'TimeHub - Preferences',
    path: 'preferences',
    canActivate: [MsalGuard],
    loadComponent: () => import('./preferences/preferences').then((m) => m.Preferences),
  },
  {
    title: 'TimeHub - Manage',
    path: 'manage',
    canActivate: [MsalGuard, powerUserGroupGuard, notImpersonatingGuard],
    loadComponent: () => import('./manage/manage').then((m) => m.Manage),
  },
  {
    title: 'TimeHub - Inspect',
    path: 'inspect',
    canActivate: [MsalGuard, powerUserGroupGuard, notImpersonatingGuard],
    loadComponent: () => import('./inspect/inspect').then((m) => m.Inspect),
  },
  {
    title: 'TimeHub - Sync',
    path: 'sync',
    canActivate: [MsalGuard, powerUserGroupGuard, notImpersonatingGuard],
    loadComponent: () => import('./sync/sync').then((m) => m.Sync),
  },
  {
    title: 'TimeHub - Impersonation',
    path: 'impersonation',
    canActivate: [MsalGuard, powerUserGroupGuard],
    loadComponent: () =>
      import('./impersonation/impersonation-page').then((m) => m.ImpersonationPage),
  },
  {
    title: 'TimeHub - Help',
    path: 'help',
    canActivate: [MsalGuard],
    loadComponent: () => import('./support/support').then((m) => m.Support),
  },
  {
    title: 'TimeHub - Unauthorized',
    path: 'unauthorized',
    component: Unauthorized,
  },
  {
    title: 'TimeHub - Not Found',
    path: '**',
    loadComponent: () => import('./status-pages/not-found/not-found').then((m) => m.NotFound),
  },
];
